import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

import { UserdropDown } from "../components";
//import { useCookies } from "react-cookie";

const Topnav = (onToggle: any) => {
  const navigate = useNavigate();
  function onClick(e: any) {
    Cookies.remove("newJwt", { path: "/" });
    navigate("/");
  }

  return (
    <nav className="navbar navbar-expand navbar-theme">
      <div className="navbar-collapse collapse">
        <ul className="navbar-nav ms-auto">
          <li>
            <UserdropDown onClick={onClick} />
          </li>
        </ul>
      </div>
    </nav>
  );
};

export { Topnav };
